export default "__VITE_ASSET__DFh$nCD9__"